// Portal Sektionen (design_handoff_control_center §4, Screen 01): Kachel je Modul mit Icon und Schalter.
// Ein Klick schaltet nur lokal um (toggleModule); übernommen wird erst mit „Speichern“ im Seitenkopf.
import { Buildings, CircleNotch, FolderSimple, GlobeSimple, Key, Layout, Pulse, Receipt, Sparkle, Users, UsersThree, type Icon } from '@phosphor-icons/react';
import { useMobilModus } from '../../../lib/immobilien/mobil';
import { CcWidget, KopfIcon } from './Rahmen';

export interface PortalModulZustand { id: string; name: string; description: string; active: boolean }

const ICON: Record<string, Icon> = {
  dashboard: Pulse, objekte: Buildings, mieter: Users, eigentuemer: Key, rechnungen: Receipt, dokumente: FolderSimple, team: UsersThree, chat: Sparkle,
};

export function PortalWidget({ module, laedt, spalte, onUmschalten }: { module: readonly PortalModulZustand[]; laedt: boolean; spalte: string; onUmschalten: (id: string) => void }) {
  // Handy: 136 statt 158 px Mindestbreite, damit zwei Kacheln nebeneinander passen
  const mindest = useMobilModus().mobil ? 136 : 158;
  return (
    <CcWidget titel="Portal Sektionen" untertitel={`${module.filter((m) => m.active).length} von ${module.length} aktiv`} spalte={spalte}
      icon={<KopfIcon flaeche="var(--acc-fill)" farbe="var(--acc-ink)"><Layout size={19} weight="fill" /></KopfIcon>}
      rechts={
        <span data-tip="Global Control – Gilt für das gesamte Portal. Mit „Speichern“ oben übernehmen." className="inline-flex items-center"
          style={{ height: 26, padding: '0 11px', gap: 6, borderRadius: 13, fontSize: 12, fontWeight: 800, background: 'var(--fill2)', color: 'var(--ink2)' }}>
          <GlobeSimple size={13} weight="bold" />Global Control
        </span>
      }>
      {laedt ? (
        <div className="flex items-center justify-center" style={{ gap: 10, padding: '40px 0', color: 'var(--ink3)', fontSize: 13.5, fontWeight: 700 }}>
          <CircleNotch size={22} weight="bold" className="animate-spin" />Wird geladen …
        </div>
      ) : (
        <div className="grid" style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${mindest}px, 1fr))`, gap: 10 }}>
          {module.map((m) => {
            const I = ICON[m.id] ?? Layout;
            return (
              <button key={m.id} type="button" aria-pressed={m.active} onClick={() => onUmschalten(m.id)}
                data-tip={`${m.name} – ${m.active ? 'Für das Portal deaktivieren' : 'Für das Portal aktivieren'}`}
                className="flex min-w-0 flex-col text-left"
                style={{ gap: 14, padding: 14, borderRadius: 20, border: 'none', cursor: 'pointer', fontFamily: 'inherit', color: 'var(--ink)', transition: 'all .25s',
                  background: m.active ? 'var(--sheet)' : 'var(--fill)', opacity: m.active ? 1 : 0.55,
                  boxShadow: m.active ? '0 6px 18px -12px var(--shade), inset 0 0 0 1px var(--line)' : 'inset 0 0 0 1px var(--line)' }}>
                <span className="flex w-full items-start justify-between" style={{ gap: 8 }}>
                  <span className="flex items-center justify-center" style={{ width: 38, height: 38, borderRadius: 12, transition: 'all .25s',
                    background: m.active ? 'var(--acc-fill)' : 'var(--fill2)', color: m.active ? 'var(--acc-ink)' : 'var(--ink3)' }}>
                    <I size={19} weight={m.active ? 'fill' : 'regular'} />
                  </span>
                  <span aria-hidden className="flex shrink-0" style={{ width: 40, height: 24, borderRadius: 12, padding: 2, transition: 'background .25s',
                    justifyContent: m.active ? 'flex-end' : 'flex-start', background: m.active ? 'var(--ok)' : 'var(--fill3)' }}>
                    <span style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff', boxShadow: '0 2px 5px rgba(0,0,0,0.25)' }} />
                  </span>
                </span>
                <span className="flex w-full min-w-0 flex-col" style={{ gap: 2 }}>
                  <span className="truncate" style={{ fontSize: 14, fontWeight: 800 }}>{m.name}</span>
                  <span className="truncate" style={{ fontSize: 12.5, color: 'var(--ink3)' }}>{m.description}</span>
                </span>
              </button>
            );
          })}
        </div>
      )}
    </CcWidget>
  );
}
